import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '@nomoh-monorepo/shared-data-access-environment';
import { IDashboardResumo, IDashboardResumoRecepcao, IDashboardResumoProfissional } from '@nomoh-monorepo/shared-types';
import { firstValueFrom } from 'rxjs';
import { DashboardDataService } from './dashboard.dataservice';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private http = inject(HttpClient);
  private environment = inject(EnvironmentService);
  private dataService = inject(DashboardDataService);

  private readonly url = `${this.environment.getApiUrl('bardo')}/agenda/dashboard`;
  private requisicoesEmAndamento = 0;
  private ultimaBuscaResumo = 0;

  async buscarResumo(dataInicio?: string, dataFim?: string): Promise<void> {
    const buscaId = ++this.ultimaBuscaResumo;
    this.iniciarCarregamento();
    try {
      let params = new HttpParams();
      if (dataInicio && dataFim) {
        params = params.set('dataInicio', dataInicio).set('dataFim', dataFim);
      }
      const resumo = await firstValueFrom(
        this.http.get<IDashboardResumo>(`${this.url}/resumo`, { params })
      );
      if (buscaId === this.ultimaBuscaResumo) {
        this.dataService.setResumo(resumo);
      }
    } finally {
      this.encerrarCarregamento();
    }
  }

  async buscarResumoRecepcao(): Promise<void> {
    this.iniciarCarregamento();
    try {
      const resumo = await firstValueFrom(
        this.http.get<IDashboardResumoRecepcao>(`${this.url}/recepcao-resumo`)
      );
      this.dataService.setResumoRecepcao(resumo);
    } finally {
      this.encerrarCarregamento();
    }
  }

  async buscarResumoProfissional(): Promise<void> {
    this.iniciarCarregamento();
    try {
      const resumo = await firstValueFrom(
        this.http.get<IDashboardResumoProfissional>(`${this.url}/profissional-resumo`)
      );
      this.dataService.setResumoProfissional(resumo);
    } finally {
      this.encerrarCarregamento();
    }
  }

  private iniciarCarregamento(): void {
    this.requisicoesEmAndamento++;
    this.dataService.setLoading(true);
  }

  private encerrarCarregamento(): void {
    this.requisicoesEmAndamento = Math.max(0, this.requisicoesEmAndamento - 1);
    this.dataService.setLoading(this.requisicoesEmAndamento > 0);
  }
}
